<template>
  <ts-loading-banner :loading="waiting">
    <div class="ts-space-y-4">
      <div class="row">
        <label class="required col-form-label col-md-12">
          {{ $t('groupChatResponsible.response') }}
        </label>
        <div class="col-md-12">
          <a-select
            v-model="model.responsed_by"
            style="width: 100%; height: 35px"
            :show-search="true"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="changeUser"
          >
            <a-select-option
              v-for="(user, index) in users"
              :key="index"
              :value="user.user_id"
            >
              {{ user.employee.name_en }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row">
        <label class="required col-form-label col-md-12">{{
          $t('groupChatResponsible.subProgram')
        }}</label>
        <div class="col-md-12">
          <a-select
            v-model="model.acps_id_list"
            mode="multiple"
            style="width: 100%; height: 35px"
            :show-search="true"
            :max-tag-count="2"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          >
            <a-select-option
              v-for="(subProgram, index) in subProgramLists"
              :key="index"
              :value="subProgram.acps_id"
            >
              {{ subProgram.acps_name_foreign }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 ts-space-y-1">
          <label>{{ $t('groupChatResponsible.remarks') }}</label>
          <textarea
            v-model="model.remarks"
            rows="3"
            class="form-control"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('remarks')">
            {{ errors.first('remarks') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting_new"
            :disabled="waiting_new || waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t('save_add_new') }}</ts-button
          >
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t('save')
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty, debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'groupChatResponsibleForm',
  data () {
    return {
      objectContain: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      users: [],
      subPrograms: [],
      branch_id: [],
      responsed_by_acps_id_list: [],
      model: {
        responsed_by: null,
        activated_type_id: null,
        acps_id_list: [],
        remarks: null
      }
    }
  },
  async created () {
    this.branch_id.push(this.$store.state.authUser.default_branch_id)
    await this.fetchResource()
    await this.setEditData()
  },
  computed: {
    ...mapState('groupChatResponsible', ['edit_data']),
    isUpdate () {
      return !isEmpty(this.edit_data)
    },
    subProgramLists () {
      if (!this.subPrograms) return []
      return this.subPrograms.filter(subProgram =>
        this.responsed_by_acps_id_list.every(s => s != subProgram.acps_id)
      )
    }
  },
  methods: {
    getActivatedTypeId (value) {
      this.model.activated_type_id = this.users.find(
        el => el.user_id == value
      ).activated_type_id
    },
    changeUser () {
      this.model.acps_id_list = []
      this.$store
        .dispatch('groupChatResponsible/find', this.model.responsed_by)
        .then(response => {
          this.responsed_by_acps_id_list = response.data.map(
            el => el.acps_id_list
          )
          this.waiting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async fetchResource () {
      this.waiting = true
      await this.$store
        .dispatch('groupChatResponsible/getUser', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.users = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.$store
        .dispatch('groupChatResponsible/getSubProgram')
        .then(response => {
          this.waiting = false
          this.subPrograms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('groupChatResponsible/store', Object.assign({}, this.model))
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$notify({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('groupChatResponsible/store', Object.assign({}, this.model))
        .then(response => {
          this.$toasted.success(response.message)
          this.clearEdit()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('groupChatResponsible/update', this.model)
        .then(response => {
          this.$notify({
            type: 'success',
            text: response.message
          })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!isEmpty(this.edit_data)) {
        this.model.responsed_by = this.edit_data.responsed_by
      }
    },
    clearEdit () {
      this.model.responsed_by = null
      this.model.activated_type_id = null
      this.model.acps_id_list = []
      this.model.remarks = null
    }
  },
  watch: {
    'model.responsed_by': debounce(function (value) {
      this.getActivatedTypeId(value)
    }, 500)
  }
}
</script>

<style lang="scss" scoped></style>
